import persist from 'vue-observable-persist'

export const createPersistObservable = <T>(observable: T, key: string) => {
  return persist(observable, {
    storage: {
      getItem (key: string) {
        if (process.browser) {
          return window.localStorage.getItem(key)
        }

        return key
      },
      setItem (key: string, value: string) {
        if (process.browser) {
          window.localStorage.setItem(key, value)
        }
      },
    },
    key,
  })
}
